import React from 'react'
import {Button} from 'react-bootstrap';
import {withRouter} from 'react-router-dom';

import success from '../../../assets/svg/auth/success.svg';

const ForgotPasswordSuccess = function (props) {

    const goToLogin = () => {
        props.history.push('/signin')
    }

    return (
        <div className="forgot-password-success">
            <img src={success}/>
            <h1 className="text-center">Link Send</h1>
            <p>password resent link has been sent on your Email. Please reset password and Sign In again</p>

            <Button variant="primary" type="submit" size="xl" onClick={goToLogin} block>Back to Sign In</Button>
        </div>
    );
}

export default withRouter(ForgotPasswordSuccess);
